module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1022-e8b23ca7b7118fa369285c970fa5f50b.png";